import React from "react";
import ShortModalLayout from "./ShortModalLayout";

export function WarningModal({ open, setOpen, message, firstButton = null, secondButton = null }) {
    return <ShortModalLayout open={open} setOpen={setOpen} firstButton={firstButton} secondButton={secondButton} title="Warning">
        {message}
    </ShortModalLayout>
}
